import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WhatsappEmbeddedSignupService } from '@app/services/whatsappEmbeddedSignup.service';

export const canActivateWhatsappEmbeddedSignup: CanActivateFn = (route, state) => {
  const whatsappService = inject(WhatsappEmbeddedSignupService);
  const router = inject(Router);

  // if (whatsappService.isWhatsappBusinessAppOnboardingErrorStatus === 0) {
  //   router.navigate(['/404']);
  //   return false;
  // }
  return true;
};
